import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AgentLog, LogStats, LogOperation } from '../types';

interface LogFilters {
  workspace?: string;
  agent?: string;
  operation?: LogOperation;
  dateRange?: [string, string];
}

interface LogState {
  logs: AgentLog[];
  filters: LogFilters;
  stats: LogStats;
  loading: boolean;
}

const initialState: LogState = {
  logs: [],
  filters: {},
  stats: {
    total: 0,
    today: 0,
    byAgent: {},
    byOperation: {},
  },
  loading: false,
};

const logSlice = createSlice({
  name: 'log',
  initialState,
  reducers: {
    setLogs: (state, action: PayloadAction<AgentLog[]>) => {
      state.logs = action.payload;
    },
    addLog: (state, action: PayloadAction<AgentLog>) => {
      state.logs.unshift(action.payload);
    },
    setFilters: (state, action: PayloadAction<LogFilters>) => {
      state.filters = action.payload;
    },
    updateFilter: (state, action: PayloadAction<Partial<LogFilters>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilters: (state) => {
      state.filters = {};
    },
    setStats: (state, action: PayloadAction<LogStats>) => {
      state.stats = action.payload;
    },
    setLogLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const {
  setLogs,
  addLog,
  setFilters,
  updateFilter,
  clearFilters,
  setStats,
  setLogLoading,
} = logSlice.actions;

export default logSlice.reducer;
